import { render } from "./SvgEditElement.vue?vue&type=template&id=68e801f7"
import script from "./SvgEditElement.vue?vue&type=script&lang=js"
export * from "./SvgEditElement.vue?vue&type=script&lang=js"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__